/**
 * Minified by jsDelivr using Terser v5.17.1.
 * Original file: /npm/kitsu-core@10.1.2/dist/index.browser.js
 *
 * Do NOT use SRI with dynamically generated files! More information: https://www.jsdelivr.com/using-sri-with-dynamic-files
 */
